/**
 * The footer.
 *
 * Short on purpose. The kit's own footer is one line — the badge, a copyright
 * and three links — and a studio site with ten pages does not need a sitemap
 * at the bottom of it. The product links are here because they are the studio's
 * only public work, so they are worth an exit.
 */
import { Link } from 'react-router-dom';

import { useI18n } from '../i18n';
import { COMPANY, PRODUCTS } from '../lib/constants';
import { Logo } from './Logo';
import styles from './Footer.module.css';

export function Footer() {
  const { t, localePath } = useI18n();
  const year = new Date().getFullYear();

  return (
    <footer className={styles.footer}>
      <div className="container">
        <div className={styles.top}>
          <div className={styles.brand}>
            <Logo size={22} onInk />
            <p className={styles.tagline}>{t.footer.tagline}</p>
          </div>

          <nav className={styles.links} aria-label={t.footer.tagline}>
            <ul className={styles.list}>
              {PRODUCTS.map((product) => (
                <li key={product.domain}>
                  <a
                    className={styles.link}
                    href={product.url}
                    target="_blank"
                    rel="noopener noreferrer"
                  >
                    {product.domain}
                  </a>
                </li>
              ))}
            </ul>

            <ul className={styles.list}>
              <li>
                <a
                  className={styles.link}
                  href={COMPANY.github}
                  target="_blank"
                  rel="noopener noreferrer"
                >
                  {t.footer.github}
                </a>
              </li>
              <li>
                <a
                  className={styles.link}
                  href={COMPANY.linkedin}
                  target="_blank"
                  rel="noopener noreferrer"
                >
                  {t.footer.linkedin}
                </a>
              </li>
              <li>
                <Link className={styles.link} to={localePath('/privacy')}>
                  {t.footer.privacy}
                </Link>
              </li>
              <li>
                <Link className={styles.link} to={localePath('/cookies')}>
                  {t.footer.cookies}
                </Link>
              </li>
            </ul>
          </nav>
        </div>

        <div className={styles.bottom}>
          <p className={styles.copyright}>
            © {year} {COMPANY.tradeName} ·{' '}
            {COMPANY.country === 'Mexico' ? 'México' : COMPANY.country}
          </p>
          <a className={styles.email} href={`mailto:${COMPANY.email}`}>
            {COMPANY.email}
          </a>
        </div>
      </div>
    </footer>
  );
}
